import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

/**
 * @param {string} id
 * @param {string} name
 * @param {string} value
 * @param {string} description
 * @param {string} placeholder
 */
const StyledNekoInput = Styled(props => {
  const { id, name, value = '', description, placeholder = '', readOnly = false } = props;

  const onChange = (e) => {
    if (props.onChange) props.onChange(e.target.value);
  }

  const onBlur = (e) => {

    if (props.onBlur && value !== e.target.value) {
      props.onBlur(e.target.value);
    }
  }

  return (
    <div className={['nui-input', props.className].join(' ')}>
      <input className="neko-input" id={id} name={name} defaultValue={value} type="text" 
        spellcheck="false"
        placeholder={placeholder} onChange={onChange} onBlur={onBlur} readOnly={readOnly} />
      {description && <p className="neko-input-description">{description}</p>}
    </div>
  );
})`
  .neko-input {
    font-family: ${Theme.fontFamily};
    font-size: ${Theme.fontSizeText};
    border: 2px solid ${Theme.blue};
    box-sizing: border-box;
    height: 30px;
    background: #e8ecff;
    padding: 0 10px;

    &::placeholder {
      color: rgba(0, 0, 0, 0.25);
    }

    :focus {
      background-color: white;
    }

    :read-only {
      background-color: ${Theme.gray};
    }
  }

  .neko-input-description {
    font-family: ${Theme.fontFamily};
    font-size: ${Theme.fontSizeSmall};
    line-height: 14px;
    margin-top: 8px;
    margin-bottom: 0;
  }
`;

const NekoInput = (props) => {
  return (<StyledNekoInput {...props} />);
}

NekoInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  readOnly: PropTypes.bool
};

NekoInput.defaultProps = {
  id: undefined,
  name: undefined,
  value: '',
  description: undefined,
  placeholder: '',
  onChange: undefined,
  onBlur: undefined,
  readOnly: false
};

export { NekoInput };
